//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable vue/no-unused-components */

import SelectionsMixin from '~/mixins/SelectionsMixin'
import Header from '~/components/Header'
import Navigation from '~/components/Navigation'
import Footer from '~sdp-components/Footer/Footer'
import Columns from '~sdp-components/PageElements/Columns'
import Column from '~sdp-components/PageElements/Column'
import ContentButton from '~sdp-components/PageElements/ContentButton.vue'
import QlikSelectedFilterPills from '~sdp-components/Qlik/QlikSelectedFilterPills'
import QlikCollapsableFilterContainer from '~sdp-components/Qlik/QlikCollapsableFilterContainer'
import PlusMinusIcon from '~sdp-components/Icons/PlusMinusIcon'
import QlikFilter from '~sdp-components/Qlik/QlikFilter'
import Square from '~sdp-components/PageElements/Square'
import Heading from '~sdp-components/PageElements/Heading'
import { default as filters, demoOnly, schoolOnly } from '~/definitions/filters'
import Dropdown from '~sdp-components/PageElements/Dropdown'

import questionsDef from '~/definitions/questions'

import ResponseRateDescription from '~/components/layout/Descriptions/ResponseRateDescription'
import HighlightsDescription from '~/components/layout/Descriptions/HighlightsDescription'
import TopicsDescription from '~/components/layout/Descriptions/TopicsDescription'
import QuestionsDescription from '~/components/layout/Descriptions/QuestionsDescription'
import TrackerDescription from '~/components/layout/Descriptions/TrackerDescription'

import responseRateTour from '~/tour/response-rate-tour'
import highlightsTour from '~/tour/highlights-tour'
import topicsTour from '~/tour/topics-tour'
import questionsTour from '~/tour/questions-tour'

const mapSurveyQuestionCodeToSurveyLabel = (surveyQuestionCode) =>
  !surveyQuestionCode
    ? ''
    : surveyQuestionCode.toLowerCase().includes('student')
    ? 'Student'
    : surveyQuestionCode.toLowerCase().includes('parent')
    ? 'Parent/Guardian'
    : surveyQuestionCode.toLowerCase().includes('teacher')
    ? 'Teacher'
    : surveyQuestionCode.toLowerCase().includes('principal')
    ? 'Principal/AP'
    : surveyQuestionCode.toLowerCase().includes('support')
    ? 'Support Staff'
    : ''

export default {
  components: {
    Header,
    Navigation,
    Footer,
    Columns,
    Column,
    ContentButton,
    QlikSelectedFilterPills,
    QlikCollapsableFilterContainer,
    PlusMinusIcon,
    QlikFilter,
    Square,
    Heading,
    Dropdown,
    HighlightsDescription,
    TopicsDescription,
    ResponseRateDescription,
    QuestionsDescription,
    TrackerDescription,
  },
  mixins: [SelectionsMixin],
  data() {
    return {
      showQuestionTopicFilters: true,
      showSchoolFilters: false,
      selectedSurveyQuestionCode: '',
      sessionObject: null,
      hypercubeValues: null,

      tourCallbacks: {
        onSkip: () => this.$store.dispatch('tour/initialize_main'),
        onFinish: () => this.$store.dispatch('tour/initialize_main'),
      },
    }
  },
  computed: {
    rightColWidth() {
      if (this.currentRouteName === 'questions') {
        return '1'
      }
      return '2/3'
    },
    currentRouteName() {
      return this.$route.name
    },
    isQuestionsRoute() {
      return this.$route.name === 'questions'
    },
    currentDescriptionComponent() {
      if (
        this.currentRouteName === 'index' ||
        this.currentRouteName === 'responserate'
      ) {
        return ResponseRateDescription
      } else if (this.currentRouteName === 'highlights') {
        return HighlightsDescription
      } else if (this.currentRouteName === 'topics') {
        return TopicsDescription
      } else if (this.currentRouteName === 'questions') {
        return QuestionsDescription
      } else if (this.currentRouteName === 'tracker') {
        return TrackerDescription
      } else {
        throw new Error(
          `${this.currentRouteName} does not have a description component, make one`
        )
      }
    },
    currentTourSteps() {
      if (
        this.currentRouteName === 'index' ||
        this.currentRouteName === 'responserate'
      ) {
        return responseRateTour
      } else if (this.currentRouteName === 'highlights') {
        return highlightsTour
      } else if (this.currentRouteName === 'topics') {
        return topicsTour
      } else if (this.currentRouteName === 'questions') {
        return questionsTour
      } else if (this.currentRouteName === 'tracker') {
        return null
      } else {
        throw new Error(
          `${this.currentRouteName} does not have a tour, make one`
        )
      }
    },

    showQuestionFiltersPanel() {
      if (this.currentRouteName === 'questions') {
        return true
      } else {
        return false
      }
    },
    showTopicFiltersPanel() {
      if (this.currentRouteName === 'topics') {
        return true
      } else {
        return false
      }
    },
    showOnlySchoolFiltersPanel() {
      if (
        this.currentRouteName === 'index' ||
        this.currentRouteName === 'highlights' ||
        this.currentRouteName === 'responserate' ||
        this.currentRouteName === 'tracker'
      ) {
        return true
      } else {
        return false
      }
    },

    filterFieldValues() {
      return this.currentRouteName === 'tracker'
        ? filters.filter(({ isSchoolLevel }) => !!isSchoolLevel)
        : //  : filters.filter(({ isSchoolLevel }) => !isSchoolLevel)
          filters
    },
    onlySchoolFilterFieldValues() {
      return schoolOnly
    },
    demoFilterFieldValues() {
      return demoOnly
    },
    anyfilterFieldsSelected() {
      const selectedFields = this.$store.state.selections.fields_with_selections
      const filterFields = filters
        .map(({ field }) => field)
        .concat('School Name')
      return selectedFields.reduce(
        (acc, field) => filterFields.includes(field) || acc,
        false
      )
    },

    topicFilterFieldValues() {
      return [{ field: 'survey', label: 'Respondent Group' }]
    },
    allTopicFieldValues() {
      return [
        { field: 'topic', label: 'Key Topic' },
        { field: 'subtopic', label: 'Key Subtopic' },
        { field: 'Construct', label: 'Topic' },
        { field: 'SubConstruct', label: 'Subtopic' },
        { field: 'survey', label: 'Respondent Group' },
        { field: 'Respondent Group', label: 'Respondent Group' },
        { field: 'Key Respondent Group', label: 'Key Respondent Group' },
      ]
    },

    // the following is for questions only
    // convert the selected code to a Survey label
    selectedSurvey() {
      if (this.isQuestionsRoute) {
        return mapSurveyQuestionCodeToSurveyLabel(
          this.selectedSurveyQuestionCode
        )
      } else {
        return null
      }
    },
    selectedConstruct() {
      if (this.isQuestionsRoute && this.selectedSurveyQuestionCode) {
        const index = this.surveyQuestionCodes.indexOf(
          this.selectedSurveyQuestionCode
        )
        if (index >= 0 && this.hypercubeValues.construct[index]) {
          return this.hypercubeValues.construct[index].text
        } else {
          return ''
        }
      } else {
        return null
      }
    },
    selectedSubConstruct() {
      if (this.isQuestionsRoute && this.selectedSurveyQuestionCode) {
        const index = this.surveyQuestionCodes.indexOf(
          this.selectedSurveyQuestionCode
        )
        if (index >= 0 && this.hypercubeValues.subConstruct[index]) {
          return this.hypercubeValues.subConstruct[index].text
        } else {
          return ''
        }
      } else {
        return null
      }
    },

    questionTextMap() {
      if (this.isQuestionsRoute) {
        const obj = {}
        this.hypercubeValues?.surveyQuestionCode.forEach(
          ({ text: code }, index) => {
            if (this.hypercubeValues?.questionText[index].text) {
              obj[code] = `${mapSurveyQuestionCodeToSurveyLabel(code)}: ${
                this.hypercubeValues?.questionText[index].text
              }`
            }
          }
        )
        return obj
      } else {
        return null
      }
    },
    questionText() {
      if (this.isQuestionsRoute) {
        return this.questionTextMap[this.selectedSurveyQuestionCode]
      } else {
        return null
      }
    },
    questionTexts() {
      if (this.isQuestionsRoute) {
        return this.hypercubeValues?.questionText.map(({ text }) => text) || []
      } else {
        return null
      }
    },
    questionFieldValues() {
      if (this.isQuestionsRoute) {
        return [
          { field: 'Respondent Group', label: 'Respondent Group' },
          { field: 'select_topic', label: 'Topic' },
          { field: 'select_subtopic', label: 'Sub-Topic', hideExcluded: true },
        ]
      } else {
        return null
      }
    },
    surveyQuestionCodes() {
      if (this.isQuestionsRoute) {
        return (
          this.hypercubeValues?.surveyQuestionCode.map(({ text }) => text) || []
        )
      } else {
        return null
      }
    },
  },
  watch: {
    anyfilterFieldsSelected() {
      // if any of the schools filters have values, set up panel to show
      if (this.anyfilterFieldsSelected) {
        this.showSchoolFilters = true
      }
    },
    async currentRouteName() {
      let fieldsToClear = []
      if (
        this.currentRouteName === 'index' ||
        this.currentRouteName === 'highlights'
      ) {
        fieldsToClear = ['Survey', 'Construct', 'SubConstruct']
      }
      const engine = await this.$qlik.engine
      fieldsToClear.forEach(async (fieldName) => {
        const field = await engine.getField(fieldName)
        await field.clear()
      })
    },
    isQuestionsRoute() {
      if (this.isQuestionsRoute) {
        this.fetchQuestionObjects()
      }
    },
  },
  created() {
    if (this.isQuestionsRoute) {
      this.fetchQuestionObjects()
    }
  },
  mounted() {
    if (!this.$store.state.tour.main_initialized) this.launchTour()
  },
  /**
   * Remove field values that we don't want to carry to other pages
   */
  async destroyed() {
    const fieldsToClear = []
    const engine = await this.$qlik.engine
    let field
    fieldsToClear.forEach(async (fieldName) => {
      field = await engine.getField(fieldName)
      await field.clear()
    })
  },
  methods: {
    async handleQuestionTextSelection(value, label) {
      await this.$qlik.setVariableValueByName(
        'v_surveyquestioncode_selected',
        value
      )
      this.selectedSurveyQuestionCode = value
    },
    async fetchQuestionObjects() {
      this.selectedSurveyQuestionCode = await this.$qlik.getVariableValueByName(
        'v_surveyquestioncode_selected'
      )
      // this is weird but the getVariable function pulls in the original value, not the current
      // so reset to original on load
      await this.$qlik.setVariableValueByName(
        'v_surveyquestioncode_selected',
        this.selectedSurveyQuestionCode
      )

      this.sessionObject = await this.$qlik.generateHypercubeObjectFromDef(
        questionsDef
      )

      this.sessionObject.on('changed', this.update)
      this.update()
    },
    async update() {
      if (this.sessionObject) {
        this.hypercubeValues = await this.$qlik.getValuesFromHypercubeObject(
          this.sessionObject
        )
        // when changing list of questions check whether the current question is still available
        // if not select the one at the top of the list
        if (
          this.isQuestionsRoute &&
          this.hypercubeValues.surveyQuestionCode &&
          this.hypercubeValues.surveyQuestionCode.filter(
            ({ text }) => text === this.selectedSurveyQuestionCode
          ).length === 0
        ) {
          await this.handleQuestionTextSelection(
            this.hypercubeValues.surveyQuestionCode[0].text
          )
        }
      }
    },
    launchTour() {
      this.$tours.mainTour.start()
    },
  },
}
